<template>
  <ul v-if="items.length" class="flex flex-col gap-4 pl-0 list-none">
    <iatl-playlist-card
      v-for="playlist in items"
      :key="playlist.slug"
      :playing="playlist.slug === playing?.slug"
      v-bind="{ playlist, theme }"
    />
  </ul>
  <slot v-else name="loading"/>
</template>

<script setup>
import IatlPlaylistCard from "@/components/podcasts/IatlPlaylistCard.vue"
import { api } from "@/api"
import { onMounted, ref } from "vue"

const props = defineProps({
  playing: Object,
  playlists: { type: Array, default: () => window.playlists },
  theme: String,
})

const items = ref([])

onMounted(() => {
  if (props.playlists) {
    items.value = props.playlists
  } else {
    api.podcastPlaylistList().then(({ data }) => {
      items.value = data
      window.playlists = data
    })
  }
})
</script>
